import type { Handler } from './handler';
import type { ApiRegisterUserJourneyEventPort } from './ports/api-register-user-journey-event.port';
import { resolveAdapter } from '~/adapters/registry';

export const registerUserJourneyEventHandler: Handler<
  Params,
  Ports,
  Result
> = async (
  { event, user, device, utm, google, facebook, tiktok, apt, deposit_id, slug },
  ports = {
    apiRegisterUserJourneyEvent: resolveAdapter('apiRegisterUserJourneyEvent'),
  },
) => {
  await ports?.apiRegisterUserJourneyEvent.handle({
    event,
    user,
    device,
    utm,
    google,
    facebook,
    tiktok,
    apt,
    deposit_id,
    slug,
  });
};

export enum UserJourneyEvent {
  ENTER_SITE = 'enter_site',
  REGISTER_USER = 'register_user',
  MAKE_DEPOSIT = 'make_deposit',
  BLOG_POST_CLICK = 'blog_post_click',
}

type Params = {
  event: UserJourneyEvent;
  user?: { id?: string };
  device?: { fingerprint?: string };
  deposit_id?: number;
  slug?: string;
  utm?: {
    source?: string;
    medium?: string;
    campaign?: string;
    id?: string;
    term?: string;
    content?: string;
  };
  google?: {
    gclid?: string;
    gbraid?: string;
    wbraid?: string;
  };
  facebook?: {
    fbclid?: string;
    fbc?: string;
    fbp?: string;
  };
  tiktok?: {
    ttclid?: string;
  };
  apt?: {
    channel?: string;
    content?: string;
    extra?: string;
  };
};

type Ports = { apiRegisterUserJourneyEvent: ApiRegisterUserJourneyEventPort };

type Result = Promise<void>;
